(function () {
  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $all(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }

  function initForm(form) {
    if (form.__bis_init) return;
    form.__bis_init = true;

    var endpoint = form.getAttribute('data-endpoint') || '';
    var msgEl = $('.back-in-stock-message', form);

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!msgEl) return;

      msgEl.textContent = '';

      var name =
        form.elements['name'] &&
        form.elements['name'].value.trim();

      var whatsapp =
        form.elements['whatsapp'] &&
        form.elements['whatsapp'].value.trim();

      var email =
        form.elements['email'] &&
        form.elements['email'].value.trim();

      // Validação
      if (!name || !whatsapp) {
        msgEl.textContent = 'Por favor preencha Nome e WhatsApp.';
        return;
      }

      // Dados enviados para o Google Apps Script
      var payload = {
        name: name,
        whatsapp: whatsapp,
        email: email || '',
        product_id:
          (form.elements['product_id'] &&
            form.elements['product_id'].value) ||
          '',
        product_title:
          (form.elements['product_title'] &&
            form.elements['product_title'].value) ||
          '',
        product_handle:
          (form.elements['product_handle'] &&
            form.elements['product_handle'].value) ||
          '',
        product_url:
          (form.elements['product_url'] &&
            form.elements['product_url'].value) ||
          '',
        shop: window.location.hostname,
        created_at: new Date().toISOString()
      };

      var btn = form.querySelector('button[type="submit"]');

      if (btn) {
        btn.disabled = true;
      }

      // Verifica endpoint
      if (!endpoint) {
        msgEl.textContent =
          'Configure o endpoint nas configurações do tema para receber os dados.';

        if (btn) {
          btn.disabled = false;
        }

        return;
      }

      console.log('Back-in-stock submit', {
        endpoint: endpoint,
        payload: payload
      });

      msgEl.textContent = 'Enviando...';

      /*
       * Monta os dados como application/x-www-form-urlencoded.
       *
       * Usamos no-cors porque o Google Apps Script não está
       * retornando o header Access-Control-Allow-Origin.
       *
       * Importante:
       * Com no-cors não podemos acessar response.json(),
       * response.status ou response.text().
       */

      var bodyParams = new URLSearchParams();

      Object.keys(payload).forEach(function (key) {
        bodyParams.append(
          key,
          payload[key] == null ? '' : payload[key]
        );
      });

      fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type':
            'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: bodyParams.toString()
      })
        .then(function () {
          /*
           * Com no-cors o navegador não permite acessar a resposta
           * do Google Apps Script.
           *
           * Portanto, não tentamos usar:
           * response.ok
           * response.status
           * response.json()
           * response.text()
           */

          console.log('Back-in-stock request enviada');

          msgEl.textContent =
            'Obrigada! Você foi adicionada à lista. Entraremos em contato assim que o produto retornar ao estoque.';

          form.reset();
        })
        .catch(function (err) {
          console.error(
            'Back-in-stock request failed',
            err
          );

          msgEl.textContent =
            'Erro ao enviar — tente novamente mais tarde.';
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
          }
        });
    });
  }

  /*
   * Inicialização dos formulários existentes
   */
  document.addEventListener('DOMContentLoaded', function () {
    $all('.back-in-stock-form').forEach(initForm);

    /*
     * Observa novos elementos adicionados dinamicamente.
     *
     * Isso é útil no Shopify quando o produto/variante ou
     * algum bloco do tema é carregado via AJAX/hydration.
     */
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (!mutation.addedNodes) return;

        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          /*
           * Caso o próprio elemento adicionado seja um formulário
           */
          if (
            node.matches &&
            node.matches('.back-in-stock-form')
          ) {
            initForm(node);
          }

          /*
           * Caso o formulário esteja dentro do elemento adicionado
           */
          if (node.querySelectorAll) {
            node
              .querySelectorAll('.back-in-stock-form')
              .forEach(initForm);
          }
        });
      });
    });

    mo.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
